<template>
	<div class="report-form">
		<div class="report-form-row-2">
			<ja-dropdown
				v-model="simulationType"
				required
				:placeholder="$t('simTypePlaceholder')"
				:label="$t('simulationTypeLbl')"
				:options="simulationTypes"
				name="simulationType"
			></ja-dropdown>
			<ja-input
				v-model="schoolInput"
				name="school"
				type="text"
				:label="$t('schoolName')"
				:placeholder="$t('schoolNamePlaceholder')"
				:disabled="facility < 0"
				escape-string
				trim-spaces
				:autocomplete-options="schools"
				@optionSelected="onSchoolSelected"
			></ja-input>
		</div>
		<div class="report-form-row-2">
			<ja-input
				v-model="educatorInput"
				name="simEducator"
				:disabled="facility < 0 || !!educatorName"
				:label="$t('educatorName')"
				:placeholder="
					educatorName ? educatorName : $t('educatorNamePlaceholder')
				"
				escape-string
				trim-spaces
				:autocomplete-options="educators"
				@optionSelected="onEducatorSelected"
			></ja-input>
			<ja-date-input
				v-model="dateInputStart"
				:disabled="simulationType < 0"
				:placeholder="$t('startDate')"
				:label="$t('selectStartDate')"
				:max-date="minStartDate"
				name="startDate"
			></ja-date-input>
		</div>
		<div class="report-form-row-2">
			<ja-date-input
				v-model="dateInputEnd"
				:label="$t('select') + ' ' + $t('endDate')"
				:placeholder="$t('endDate')"
				:max-date="minStartDate"
				:min-date="dateInputStart"
				name="endDate"
				:disabled="simulationType < 0"
			></ja-date-input>
		</div>
	</div>
</template>
<script>
import ReportingMixin from '@/mixins/ReportingMixin';
import AdminFacility from '@/mixins/AdminFacility';
import Input from '@/components/ui/form/Input';
import Dropdown from '@/components/ui/form/Dropdown';
import DateInput from '@/components/ui/form/DateInput';

export default {
	components: {
		jaInput: Input,
		jaDropdown: Dropdown,
		jaDateInput: DateInput
	},
	mixins: [ReportingMixin, AdminFacility],
	props: {
		filters: {
			type: Object,
			default: null
		},
		simulationTypes: {
			type: Array,
			default: () => {
				return [];
			}
		},
		educatorName: {
			type: String,
			default: ''
		},
		clear: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			dateInputStart: null,
			dateInputEnd: null
		};
	},
	computed: {
		activeFilters() {
			if (this.filters) {
				return this.filters;
			}

			return {
				facility: this.selectedFacilityId,
				simulationType: null,
				school: null,
				educator: null,
				simulationClass: null,
				student: null,
				startDate: null,
				endDate: null,
				visitStartDate: null,
				visitEndDate: null
			};
		},
		requiredFieldsPopulated() {
			return this.selectedFacilityId >= 0 && this.simulationType >= 0;
		},
		minStartDate() {
			return new Date();
		},
		minEndDate() {
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			return today;
		}
	},
	watch: {
		clear(value) {
			if (value === true) {
				this.facilityChanged();
			}
		},
		selectedFacility(newValue) {
			this.activeFilters.facility = newValue.facility_ID;

			this.$emit('filtersUpdated', this.activeFilters);
		},
		simulationType(newValue) {
			if (newValue >= 0) {
				this.activeFilters.simulationType = this.simulationTypes[
					newValue
				].value;
			} else {
				this.activeFilters.simulationType = null;
			}
			this.$emit('filtersUpdated', this.activeFilters);
		},
		school(newValue) {
			this.activeFilters.school = newValue;

			this.$emit('filtersUpdated', this.activeFilters);
		},
		educator(newValue) {
			this.activeFilters.educator = newValue;

			this.$emit('filtersUpdated', this.activeFilters);
		},
		dateInputStart(newDate) {
			if (newDate == null) {
				this.activeFilters.startDate = null;
				this.$emit('filtersUpdated', this.activeFilters);
				return;
			}
			if (this.simulationType >= 0) {
				const startDate = this.formatDate(newDate);
				this.activeFilters.startDate = startDate;
				this.$emit('filtersUpdated', this.activeFilters);
			}
		},
		dateInputEnd(newDate) {
			if (newDate == null) {
				this.activeFilters.endDate = null;
				this.$emit('filtersUpdated', this.activeFilters);
				return;
			}
			if (this.simulationType >= 0) {
				const endDate = this.formatDate(newDate);
				this.activeFilters.endDate = endDate;
				this.$emit('filtersUpdated', this.activeFilters);
			}
		}
	},
	mounted() {
		if (this.educatorName) {
			this.educator = this.educatorName;
		}
	},
	methods: {
		facilityChanged() {
			this.simulationType = -1;
			this.dateInputStart = null;
			this.dateInputEnd = null;
			this.schoolInput = '';
			this.educatorInput = '';

			this.educators = [];
			this.schools = [];
		},
		formatDate(date) {
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();
			return `${month}-${day}-${year}`;
		}
	}
};
</script>
